
// 插件路由
const recommend = () => import(/* webpackChunkName: "example" */ '~/addon/recommend/pages/recommend.vue')

const routes = [
	{ 
        path: '/recommend', 
        component: recommend 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/recommend/router/index.js